<template>
  <v-layout class="idcs-main-back">
    <v-tabs id="admin-tab" v-model="tab" class="idcs-main-back fill-height">
      <v-tab>{{$t('admin.usersupp')}}</v-tab>
      <v-tab>{{$t('admin.reports')}}</v-tab>
      <v-tab>{{$t('admin.errors')}}</v-tab>
      <v-tab>{{$t('admin.bins')}}</v-tab>
      <v-tab>{{$t('admin.frames')}}</v-tab>
      <v-tab>{{$t('admin.freecards')}}</v-tab>
      <v-tab>{{$t('admin.baseutils')}}</v-tab>
      <v-tabs-items class="idcs-main-back fill-height" v-model="tab">
        <v-tab-item class="idcs-main-back mt-10">
          <v-layout fluid wrap justify-center>
            <v-btn fab dark absolute top right color="pink" @click="addGroup">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-container fluid>
              <v-row align-content="center">
                <v-col v-for="(l,i) in iflegend" :key="i">
                  <v-chip :color="l.col" class="mr-2">{{l.chip}}</v-chip>
                  {{l.leg}}
                </v-col>
              </v-row>
            </v-container>
            <v-flex
              class="ma-1"
              xs12
              sm12
              md5
              lg4
              xl3
              v-for="g in $store.getters['admin/groups']"
              :key="g.id"
              wrap
            >
              <v-card class="idcs-data-back">
                <v-card-actions>
                  <v-subheader>
                    <v-chip class="mr-1" :color="iface(g,'col')">{{iface(g,'chip')}}</v-chip>
                    <v-icon>mdi-account-multiple</v-icon>
                    <span class="text-uppercase">{{g.id}}</span>
                  </v-subheader>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="editGroup(g)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon @click="addUser(g)">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-card-text v-if="g.children">
                  <v-btn
                    text
                    v-for="u in g.children"
                    :key="u.name"
                    :color="userColor(u.status)"
                    @click="editUser(u.name)"
                  >
                    <v-icon>mdi-account</v-icon>
                    {{u.name}}
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item class="idcs-main-back mt-10">
          <v-layout fluid wrap justify-center>
            <v-btn fab dark absolute top right color="pink" @click="addReport">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-flex
              class="ma-5"
              xs12
              sm4
              md3
              lg2
              xl2
              v-for="r in $store.getters['admin/reports']"
              :key="r.id"
            >
              <v-card>
                <v-card-actions>
                  <v-subheader>
                    <v-chip class="text-uppercase mr-2 title" dark color="blue lighten-2">{{r.id}}</v-chip>
                  </v-subheader>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="editError('_'+r.name_id)">
                    <v-icon>mdi-translate</v-icon>
                  </v-btn>
                  <v-btn icon @click="editReport(r.id)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <template v-for="(v,k) in $store.getters['admin/error']('_'+r.name_id)">
                    <div :key="k" v-if="v">
                      <span class="ma-2">{{k.toUpperCase()}}</span>
                      <span class="orange--text">{{v}}</span>
                    </div>
                  </template>
                </v-card-text>
              </v-card>
            </v-flex>

            <!--          <v-simple-table>
            <thead>
              <th></th>
              <th>{{$t('field.id')}}</th>
              <th>{{$t('field.name_id')}}</th>
            </thead>
            <tbody>
              <tr v-for="r in $store.getters['admin/reports']" :key="r.id">
                <td>
                  <v-btn icon @click="editReport(r.id)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </td>
                <td>{{r.id}}</td>
                <td>{{r.name_id}}</td>
              </tr>
            </tbody>
            </v-simple-table> !-->
          </v-layout>
        </v-tab-item>
        <v-tab-item class="idcs-main-back mt-10">
          <v-layout row fluid wrap>
            <v-btn fab dark absolute top right color="pink" @click="addError">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-flex xs9>
              <v-btn-toggle v-model="lang" group class="ma-2 d-inline" mandatory multiple>
                <v-btn v-for="l in $store.getters['admin/errors_loc']" :key="l">{{l|lang}}</v-btn>
              </v-btn-toggle>
            </v-flex>
            <v-flex xs2>
              <v-text-field
                v-model="pattern"
                clearable
                :label="$t('admin.errorid')"
                outlined
                background-color="yellow lighten-5"
                color="black"
                shaped
                append-icon="mdi-magnify"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-simple-table>
            <thead>
              <th></th>
              <th>{{$t('admin.errorid')}}</th>
              <th v-for="l in selslangs" :key="l">{{l|lang}}</th>
            </thead>
            <tbody>
              <tr v-for="k in $store.getters['admin/ekeysfilt'](pattern)" :key="k">
                <td>
                  <v-btn icon @click="editError(k)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </td>
                <td>{{k | erCode}}</td>
                <td v-for="l in selslangs" :key="l">{{$store.getters['admin/error'](k)[l]}}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="idcs-main-back">
          <v-simple-table>
            <thead>
              <th v-for="h in hbin" :key="h.value">{{$t('field.'+h.name)}}</th>
            </thead>
            <tbody>
              <tr v-for="r in $store.getters['admin/bins']" :key="r.created">
                <td v-for="h in hbin" :key="h.value">
                  <span v-if="h.value=='status'">{{$t('status.'+r[h.value])}}</span>
                  <v-btn
                    text
                    v-else-if="h.value=='bin'"
                    color="indigo"
                    :to="'/struct?sys='+r[h.value]"
                  >{{r[h.value]}}</v-btn>
                  <span v-else-if="h.value=='valid'">{{r[h.value]|dt-time}}</span>
                  <span v-else-if="h.value=='created'">{{r[h.value]|dt-time}}</span>
                  <span v-else-if="h.value=='last_modified'">{{r[h.value]|dt-time}}</span>
                  <div
                    v-else-if="h.value=='need_oper_nr'"
                    class="text-center"
                  >{{r[h.value] | plusempty}}</div>
                  <div v-else-if="h.value=='pin_flag'" class="text-center">{{r[h.value]}}</div>
                  <div
                    v-else-if="h.value=='just_trans'"
                    class="text-center"
                  >{{r[h.value] | plusempty}}</div>
                  <div
                    v-else-if="h.value=='debit_in'"
                    class="text-center"
                  >{{r[h.value] | plusempty}}</div>
                  <span v-else>{{r[h.value]}}</span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-tab-item>
        <!-- frames -->
        <v-tab-item class="idcs-main-back">
          <v-btn fab dark absolute top right color="pink" @click="addFrame">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-simple-table>
            <thead>
              <th>{{$t('admin.actions')}}</th>
              <th v-for="h in hframes" :key="h.value">{{$t('field.'+h.name)}}</th>
            </thead>
            <tbody>
              <tr v-for="r in frames" :key="r.idx">
                <td>
                  <v-btn icon @click="editFrame(r)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon @click="showFrame=true, rec2sett=r">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </td>
                <td v-for="h in hframes" :key="h.value">
                  <span
                    v-if="h.value=='systemid'"
                  >{{$store.getters['struct/systemById'](r[h.value])?$store.getters['struct/systemById'](r[h.value]).text:""}}</span>
                  <span v-else-if="h.value=='format'">{{$t('admin.frame_type')[r[h.value]]}}</span>
                  <span v-else>{{r[h.value]}}</span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-tab-item>
        <v-tab-item class="idcs-main-back">
          <EKKFreeCards />
        </v-tab-item>
        <v-tab-item class="idcs-main-back fill-height">
          <EKKBaseUtils />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <FrameSetting v-model="showFrame" :record="rec2sett"></FrameSetting>
    <v-dialog v-model="editDialog" fullscreen>
      <component
        ref="edt"
        :is="editType"
        v-bind="dialogParams"
        v-model="editDialog"
        @update="onUpdateRecord"
        @insert="onInsertRecord"
        @delete="onDeleteRecord"
      ></component>
    </v-dialog>
  </v-layout>
</template>
<script>
import app from "@/app.js";
import * as components from "@/components/editTypes/admins.js";

export default {
  components: { ...components },
  data() {
    return {
      showFrame: false,
      lang: [0],
      tab: 0,
      rec2sett: {},
      editDialog: false,
      dialogParams: false,
      editType: null,
      pattern: "",
      iflegend: [
        {
          chip: "P",
          col: "gray",
          leg: "default",
        },
        {
          chip: "A",
          col: "green lighten-3",
          leg: this.$t("admin.interface_type.0"),
        },
        {
          chip: "P",
          col: "amber lighten-3",
          leg: this.$t("admin.interface_type.1"),
        },
        {
          chip: "S",
          col: "deep-purple accent-1",
          leg: this.$t("admin.interface_type.2"),
        },
        {
          chip: "G",
          col: "purple lighten-2",
          leg: this.$t("admin.interface_type.3"),
        },
        {
          chip: "R",
          col: "orange",
          leg: this.$t("admin.interface_type.4"),
        },
      ],
      hbin: [
        { value: "bin", name: "bin" },
        { value: "name", name: "name" },
        { value: "valid", name: "valid" },
        { value: "status", name: "status" },
        { value: "debit_in", name: "debetIn" },
        { value: "need_oper_nr", name: "needOperNr" },
        { value: "just_trans", name: "justTrans" },
        { value: "pin_flag", name: "pinFlag" },
        { value: "created", name: "created_" },
        { value: "last_modified", name: "modified" },
      ],
      hframes: [
        { value: "name", name: "name" },
        { value: "last_used", name: "last_used" },
        { value: "systemid", name: "system" },
        { value: "format", name: "frametype" },
        { value: "errors", name: "errors" },
        { value: "used", name: "used" },
      ],
    };
  },
  filters: {
    lang(v) {
      if (v && v.indexOf("g_") == 0) return v.substring(2) + " - def";
      return v;
    },
    erCode(v) {
      return v.substring(1);
    },
  },
  computed: {
    frames() {
      return this.$store.getters["admin/frames"];
    },
    sortedErrors() {
      return Object.keys(this.$store.getters["admin/errors"]).sort();
    },
    selslangs() {
      let ret = [];
      this.lang.forEach((e) => {
        ret.push(this.$store.getters["admin/errors_loc"][e]);
      });
      return ret;
      // if (this.lang == 0) return this.$store.getters["admin/errors_loc"];
      // return [this.$store.getters["admin/errors_loc"][this.lang - 1]];
    },
  },
  async mounted() {
    try {
      if (!this.$store.getters["struct/isLoaded"]) {
        await this.$store.dispatch("struct/LOAD_STRUCT");
      }
      this.$store.dispatch("admin/LOAD");
      this.$store.dispatch("admin/LOAD_ERROR");
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    iface(g, f) {
      try {
        let i = /<interface>(\d)<\/interface>/g.exec(g.rules)[1];
        return this.iflegend[parseInt(i) + 1][f];
      } catch (e) {
        return this.iflegend[0][f];
      }
    },
    userColor(s) {
      switch (s) {
        case 1:
        case 2:
          return "gray";
        case 4:
          return "blue lighten-2";
        case 100:
        default:
          return "green lighten-2";
      }
    },
    editReport(r) {
      app.select(r, "ReportRecord").then((response) => {
        this.dialogParams = { record: response };
        this.editType = "ReportRecord";
        this.editDialog = true;
      });
    },
    editError(k) {
      this.dialogParams = { errorId: k, newrec: true };
      this.editType = "ErrorRecord";
      this.editDialog = true;
    },
    addError() {
      this.dialogParams = { errorId: "", newrec: true };
      this.editType = "ErrorRecord";
      this.editDialog = true;
    },
    addReport() {
      this.dialogParams = { record: { id: null }, newrec: true };
      this.editType = "ReportRecord";
      this.editDialog = true;
    },
    addGroup() {
      this.dialogParams = { record: { rules: "" }, newrec: true };
      this.editType = "UserGroupRecord";
      this.editDialog = true;
    },
    editFrame(i) {
      this.dialogParams = { record: i };
      this.editType = "FrameRecord";
      this.editDialog = true;
    },
    addFrame() {
      this.dialogParams = {
        record: { systemid: null, hashid: "", format: 0 },
        newrec: true,
      };
      this.editType = "FrameRecord";
      this.editDialog = true;
    },
    addUser(g) {
      this.dialogParams = {
        record: { userGroup: g.id, status: 4 },
        newuser: true,
      };
      this.editType = "UserRecord";
      this.editDialog = true;
    },
    editUser(u) {
      app.select(u, "UserRecord").then((response) => {
        this.dialogParams = { record: response };
        this.editType = "UserRecord";
        this.editDialog = true;
      });
    },
    editGroup(e) {
      app.select(e.id, "UserGroupRecord").then((response) => {
        this.dialogParams = { record: response };
        this.editType = "UserGroupRecord";
        this.editDialog = true;
      });
    },
    onUpdateRecord() {},
    onInsertRecord() {},
    onDeleteRecord(i) {
      this.$store.commit("admin/remove_user", i);
    },
  },
};
</script>
<style lang="scss" scoped>
table thead {
  background-color: aliceblue;
}
</style>>
